import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { IAnnouncementsState } from './announcements.reducer';
import * as fromReducer from './announcements.reducer';

const getAnnouncementsState = createFeatureSelector<IAnnouncementsState>('announcements');

export const getAnnouncements = createSelector(getAnnouncementsState, fromReducer.getAnnouncements);
export const hasNextPageAnnouncements = createSelector(
  getAnnouncementsState,
  fromReducer.hasNextPage
);
export const getLatestAnnouncements = createSelector(
  getAnnouncementsState,
  fromReducer.getLatestAnnouncements
);
export const getAnnouncementsActionState = createSelector(
  getAnnouncementsState,
  fromReducer.getAnnouncementsActionState
);
export const getAnnouncement = createSelector(getAnnouncementsState, fromReducer.getAnnouncement);
export const getAnnouncementActionState = createSelector(
  getAnnouncementsState,
  fromReducer.getAnnouncementActionState
);
export const getAnnouncementPageInfo = createSelector(
  getAnnouncementsState,
  fromReducer.getAnnouncementPageInfo
);
